import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const transactionApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/admin/transaction`;

export const getAdminTransactionsListThunk = createAsyncThunk(
    "admin-transactions-list",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${transactionApiEndPoint}/list`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch transactions" }
            )
        }
    }
)

export const getAdminTransactionDetailsThunk = createAsyncThunk(
    "admin-transaction-details",
    async ({ token, transactionId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${transactionApiEndPoint}/details/${transactionId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch transaction" }
            )
        }
    }
)
